/* =============================================================================
 * Tusq Apparel — PDP v2 *additions* only
 * v63.9 (2026-09-21): Wave 2 — sold-out size UX (badge + toast + click intercept)
 *   Addresses Revenue Leak #8 + Item 6 diagnosis finding (variant availability UX).
 *   Clarity showed: users tap sold-out sizes, get no feedback, don't recover.
 *   Fix: visible SOLD OUT badge on disabled buttons; on click, show toast
 *        ("Size not available — try a different size").
 * v63.x (original): Sticky ATC visibility + state sync with primary ATC.
 * ============================================================================= */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // ---------------------------------------------------------------------------
  // v63.9 — Sold-out size UX (badges + toast)
  // ---------------------------------------------------------------------------
  var TUSQ_TOAST_CSS = '\
    .tusq-toast{position:fixed;left:50%;bottom:96px;transform:translateX(-50%) translateY(20px);\
      background:#0d0e0e;color:#fff;padding:12px 20px;border-radius:8px;font-family:inherit;\
      font-size:14px;font-weight:600;box-shadow:0 8px 24px rgba(0,0,0,.24);z-index:99998;\
      opacity:0;transition:opacity .2s ease,transform .2s ease;pointer-events:none;max-width:90vw;text-align:center}\
    .tusq-toast[data-show="true"]{opacity:1;transform:translateX(-50%) translateY(0)}\
    /* Sold-out badge on size buttons */\
    .product-form__input input[type="radio"]:disabled+label,\
    fieldset.product-form__input label[data-unavailable],\
    .product-form__input .disabled{position:relative;opacity:.55}\
    .product-form__input input[type="radio"]:disabled+label::after,\
    fieldset.product-form__input label[data-unavailable]::after{\
      content:"Sold out";position:absolute;top:-8px;right:-4px;background:#0d0e0e;color:#fff;\
      font-size:9px;font-weight:700;letter-spacing:.5px;padding:2px 6px;border-radius:3px;\
      text-transform:uppercase;line-height:1;white-space:nowrap;pointer-events:none}\
  ';
  function injectToastStyles(){
    if(document.getElementById('tusq-toast-styles'))return;
    var s=document.createElement('style');s.id='tusq-toast-styles';s.textContent=TUSQ_TOAST_CSS;document.head.appendChild(s);
  }
  var _toastEl=null,_toastTimer=null;
  function showToast(msg){
    injectToastStyles();
    if(!_toastEl){_toastEl=document.createElement('div');_toastEl.className='tusq-toast';_toastEl.setAttribute('role','status');_toastEl.setAttribute('aria-live','polite');document.body.appendChild(_toastEl);}
    _toastEl.textContent=msg;
    _toastEl.setAttribute('data-show','true');
    if(_toastTimer)clearTimeout(_toastTimer);
    _toastTimer=setTimeout(function(){_toastEl.setAttribute('data-show','false');},2600);
  }
  function initSoldOutUX(){
    injectToastStyles();
    // Delegated click on any disabled size input's label (buttons/pills)
    document.addEventListener('click',function(e){
      var t=e.target;
      if(!t)return;
      // Case 1: <label for="X"> where input#X is disabled
      var lbl=t.closest && t.closest('.product-form__input label');
      if(lbl){
        var input=lbl.control||document.getElementById(lbl.getAttribute('for'));
        if(input&&input.disabled){
          e.preventDefault();e.stopPropagation();
          showToast('Size not available — try a different size');
          return;
        }
      }
      // Case 2: element flagged as data-unavailable
      var unavail=t.closest && t.closest('[data-unavailable]');
      if(unavail){
        e.preventDefault();e.stopPropagation();
        showToast('Size not available — try a different size');
      }
    },true);
  }

  // ---------------------------------------------------------------------------
  // Sticky ATC visibility — observe when the primary ATC scrolls off-screen
  // ---------------------------------------------------------------------------
  function initStickyATC() {
    var sticky = document.querySelector('[data-tusq-sticky-atc]');
    if (!sticky) return;

    var primaryATC =
      document.querySelector('product-info .product-form__submit') ||
      document.querySelector('product-info .product-form button[type="submit"]') ||
      document.querySelector('.product-form__submit');

    if (!primaryATC) {
      // Fallback: scroll-distance threshold
      window.addEventListener('scroll', function () {
        var show = window.scrollY > 600;
        sticky.dataset.visible = show ? 'true' : 'false';
        sticky.removeAttribute('hidden');
      }, { passive: true });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var rect = entry.boundingClientRect;
        var showSticky = !entry.isIntersecting && rect.top < 0;
        sticky.dataset.visible = showSticky ? 'true' : 'false';
        if (showSticky) sticky.removeAttribute('hidden');
      });
    }, { threshold: 0, rootMargin: '0px 0px -50px 0px' });

    observer.observe(primaryATC);
  }

  // ---------------------------------------------------------------------------
  // Sync sticky CTA label and disabled state with primary ATC
  // ---------------------------------------------------------------------------
  function initStickySync() {
    var primary =
      document.querySelector('product-info .product-form__submit') ||
      document.querySelector('.product-form__submit');
    var stickyCta = document.querySelector('[data-tusq-sticky-cta]');
    if (!primary || !stickyCta) return;

    function syncState() {
      var disabled = primary.getAttribute('aria-disabled') === 'true' || primary.disabled;
      var label = (primary.querySelector('span:not(.hidden):not([class*="sold"])') || primary).textContent.trim();
      stickyCta.disabled = !!disabled;
      if (label) stickyCta.textContent = label;
    }
    syncState();

    var mo = new MutationObserver(syncState);
    mo.observe(primary, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  ready(function () {
    initStickyATC();
    initStickySync();
    initSoldOutUX();  // v63.9
  });
})();
